
// export const setOpenId = function (state, openid) {
//   state.openid = openid
// }

export const setUsername = function(state, username) {
  state.username = username
}

// export const setAvatar = function(state, avatar) {
//   state.avatar = avatar
// }




// WEBPACK FOOTER //
// ./src/store/wechat/mutations.js